
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCoreProductPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  x: 15.273,
  y: 4.364,
  width: 2.182,
  height: 23.273,
  rx: 1.091
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.636 16.364a1.09 1.09 0 0 1-1.09 1.09H5.454a1.09 1.09 0 1 1 0-2.181h21.09c.603 0 1.091.488 1.091 1.09Z"
}))));

      const __svgRaw = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\r\n<svg width=\"32px\" height=\"32px\" viewBox=\"0 0 32 32\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\r\n    <title>icon/32/plus</title>\r\n    <g id=\"icon/32/plus\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\r\n        <rect id=\"Rectangle-Copy-15\" fill=\"#000000\" x=\"15.2727273\" y=\"4.36363636\" width=\"2.18181818\" height=\"23.2727273\" rx=\"1.09090909\"></rect>\r\n        <path d=\"M16,4.72727273 C16.6024925,4.72727273 17.0909091,5.21568936 17.0909091,5.81818182 L17.0909091,26.9090909 C17.0909091,27.5115834 16.6024925,28 16,28 C15.3975075,28 14.9090909,27.5115834 14.9090909,26.9090909 L14.9090909,5.81818182 C14.9090909,5.21568936 15.3975075,4.72727273 16,4.72727273 Z\" id=\"Rectangle-Copy-16\" fill=\"#000000\" transform=\"translate(16.000000, 16.363636) rotate(-270.000000) translate(-16.000000, -16.363636) \"></path>\r\n    </g>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/coreProductPlus.47634b6fe9852c92b79b98d28ca4b1c4.svg"),
        {
          React: SvgCoreProductPlus,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      